import { sanitized } from 'volta/utils/text-utils';
import { service } from '@ember/service';
import DomainSelect from 'volta/components/domain-select';
import type LabelService from 'volta/services/label-service';
import type PartType from 'volta/models/part-type';

export default class PartTypeSelect extends DomainSelect<PartType, {}> {
  @service labelService!: LabelService;

  get infiniteScroll() {
    return false;
  }

  get propertyKey() {
    return 'code';
  }

  get idKey() {
    return 'id';
  }

  async searchPromise({ search }: Record<string, any>) {
    let partTypes: PartType[] = this.store.peekAll<PartType>('part-type').slice();
    const { values = [] } = this;
    if (partTypes.length === 0) {
      partTypes = (
        await this.store.query<PartType>('part-type', {
          page: { limit: 100, offset: 0 },
          sort: 'code'
        })
      ).slice();
    }
    return search != null && search !== ''
      ? partTypes.filter((pt) => {
          const toSearch = this.labelService.tOrElse(pt.code, pt.description);
          return (
            pt.id &&
            (sanitized(toSearch as string).includes(sanitized(search)) || values.includes(pt.id))
          );
        })
      : partTypes;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    PartTypeSelect: typeof PartTypeSelect;
    'part-type-select': typeof PartTypeSelect;
  }
}
